import PropTypes from 'prop-types';
import React from 'react';
import Link from 'next/link';
import StyledNewsroomSection from './newsroomSection.style';
import Headline from '../../atoms/headline/headline';
import TeaserContainer from '../teaser-container/teaserContainer';
import ContactList from '../../molecules/contact-list/contactList';
import MixedCopy from '../../molecules/mixed-copy/mixedCopy';
import Container from '../../layout/container/container';
import Download from '../../molecules/download/download';
import { ArrowRight } from '../../icons/arrow/arrow';
import PressForm from '../press-form/pressForm';

const renderEntries = block => ({
  articles: <TeaserContainer data={block.entries} />,
  events: <TeaserContainer data={block.entries} />,
  pressKits: <TeaserContainer data={block.entries} />,
  pressContact: (
    <Container>
      <ContactList person={block.entries} />
    </Container>
  ),
  downloads: (
    <Container>
      {block.entries && block.entries.map(download => <Download key={download.id} {...download} />)}
    </Container>
  ),
  copy: (
    <Container>
      <MixedCopy html={block.html} />
    </Container>
  ),
  download: (
    <Container>
      <Download {...block.data} />
    </Container>
  ),
  pressDistributorForm: (
    <Container>
      <PressForm />
    </Container>
  )
});

const NewsroomSection = ({ type, headline, headlineId, listUrl, listUrlText, ...props }) => (
  <StyledNewsroomSection {...props}>
    {headline && (
      <Container>
        <Headline secondary tag="h2" className="newsroomSection__headline" id={headlineId}>
          {headline}
        </Headline>
      </Container>
    )}

    {renderEntries(props)[type]}

    {listUrl && (
      <Container className="newsroomSection__link-wrapper">
        <Link
          href={{ pathname: `/universal`, query: { uri: listUrl } }}
          as={listUrl}
          className="newsroomSection__link"
        >
          {listUrlText}
          <ArrowRight />
        </Link>
      </Container>
    )}
  </StyledNewsroomSection>
);

NewsroomSection.propTypes = {
  type: PropTypes.string.isRequired,
  headline: PropTypes.string,
  headlineId: PropTypes.string,
  entries: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  listUrl: PropTypes.string,
  listUrlText: PropTypes.string
};

export default NewsroomSection;
